// Filename: HomeButtonStyle.ts
//
// Component: Home Button Styles
//
// Purpose:
// Provide reusable style classes for the HomeButton Component
// Page, keeping styling separate from logic and makes UI consistent.
//
// What this file does:
// - Uses MUI's `makeStyles` hook to access theme variables.
import { makeStyles } from "tss-react/mui";

export const useHomeButtonStyles = makeStyles()((theme) => ({
  outerButton: {
    backgroundColor: theme.palette.background.default,
    height: 32,
    width: 32,
    minWidth: 32,
    borderRadius: 50,
    padding: 0,
  },
}));
